module.exports = __webpack_public_path__ + "img/webGL.07d38363.png";